export default __webpack_public_path__ + "static/media/last-section-background.b9cf3559.png";